@if (visible) {
  @if (!hasNotes) {
    <div class="notes-card">
      <div class="notes-left">
        <h3 class="notes-heading">{{ 'NOTES.TITLE' | translate }}</h3>
        <p class="notes-subtitle">{{ 'NOTES.NO_NOTES' | translate }}</p>
      </div>
      <button class="btn-add-note" type="button" (click)="addNote()">
        {{ 'NOTES.ADD_NOTE' | translate }}
      </button>
    </div>
  }

  @if (hasNotes) {
    <div class="notes-card has-notes">
      <div class="notes-section">
        <!-- Header: collapse toggle + title + badge (when collapsed) -->
        <button class="notes-header" type="button" (click)="toggleNotesExpanded()">
          <span class="notes-toggle" [class.expanded]="notesExpanded">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 13.7658 9.14123" fill="none">
              <path d="M6.11099 0.364293C6.511 -0.121431 7.25484 -0.121431 7.65485 0.364293L13.5359 7.50553C14.0731 8.1579 13.6091 9.14123 12.7639 9.14123H1.0019C0.156783 9.14123 -0.307277 8.1579 0.229972 7.50553L6.11099 0.364293Z" fill="#50A8FF"/>
            </svg>
          </span>
          <h3 class="notes-heading">{{ 'NOTES.TITLE' | translate }}</h3>
          @if (!notesExpanded) {
            <span class="notes-collapse-badge">{{ space!.notes.length }} {{ 'NOTES.TITLE' | translate }}</span>
          }
        </button>
        <!-- Note list -->
        @if (notesExpanded) {
          <div class="notes-list">
            @for (note of space!.notes; track note; let i = $index) {
              <div class="note-row">
                @if (editingIndex === i) {
                  <!-- Inline edit mode -->
                  <textarea
                    class="note-edit-textarea"
                    [(ngModel)]="editingText"
                    (keydown.escape)="cancelInlineEdit()"
                  ></textarea>
                  <div class="note-actions">
                    <button class="note-icon-btn" type="button" (click)="saveInlineEdit(i)" [attr.title]="'NOTES.SAVE' | translate">
                      <!-- Floppy disk / save icon -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0066CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
                        <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/>
                        <path d="M7 3v4a1 1 0 0 0 1 1h7"/>
                      </svg>
                    </button>
                    <button class="note-icon-btn" type="button" (click)="cancelInlineEdit()" [attr.title]="'NOTES.CANCEL' | translate">
                      <!-- X / discard icon -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0066CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 6 6 18"/>
                        <path d="m6 6 12 12"/>
                      </svg>
                    </button>
                  </div>
                } @else {
                  <!-- Read mode -->
                  <p class="note-text">{{ note.text }}</p>
                  <div class="note-actions">
                    <button class="note-icon-btn" type="button" (click)="startInlineEdit(note, i)" [attr.title]="'NOTES.EDIT' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18.2141 21.0739" fill="none">
                        <path d="M0.429306 17.2874C0.213261 17.107 0.116508 16.8204 0.179247 16.5454L0.900157 13.3873L0.92368 13.3046C0.952329 13.2234 0.994914 13.1475 1.04951 13.0804L9.227 3.03327C9.35374 2.87762 9.53805 2.77923 9.73758 2.75977C9.93693 2.7404 10.1357 2.80158 10.2893 2.92968L15.8045 7.53332C16.1193 7.7961 16.1637 8.26447 15.9044 8.58327L7.72677 18.6294C7.65303 18.72 7.55898 18.7926 7.45256 18.8406L4.52907 20.1589C4.26728 20.277 3.96116 20.2358 3.74103 20.0522L0.429306 17.2874ZM4.34253 18.5993L6.67718 17.5465L14.2732 8.21347L9.90872 4.57006L2.32222 13.8894L1.74256 16.4283L4.34253 18.5993Z" fill="#0066CC"/>
                        <path d="M0.750165 20.3239L4.22189 19.4755L0.910114 16.7108L0.750165 20.3239Z" fill="#0066CC"/>
                        <path d="M0.000710686 20.293L0.161335 16.6793C0.173978 16.3942 0.347175 16.1401 0.608192 16.0245C0.869125 15.9091 1.17303 15.952 1.39165 16.1345L4.70337 18.8994C4.92022 19.0806 5.01613 19.3686 4.95177 19.6444C4.88731 19.9203 4.67298 20.1375 4.39782 20.2047L0.926358 21.0525C0.697287 21.1084 0.455602 21.0536 0.273651 20.9042C0.091809 20.7548 -0.00955174 20.5285 0.000710686 20.293ZM2.5997 19.1006L1.59168 18.2589L1.54321 19.3586L2.5997 19.1006Z" fill="#0066CC"/>
                        <path d="M9.32751 4.08345C9.0127 3.82064 8.96749 3.35209 9.227 3.03327L11.0432 0.802821C11.8083 -0.13677 13.1866 -0.271217 14.1146 0.503323L17.4263 3.2682C18.3488 4.0383 18.4801 5.41872 17.7196 6.35292L15.9044 8.58327C15.7776 8.73895 15.593 8.83763 15.3935 8.85709C15.1941 8.87644 14.9954 8.81535 14.8417 8.68719L9.32751 4.08345ZM15.2215 7.04787L16.5575 5.40656C16.7988 5.11003 16.7566 4.66625 16.4638 4.42174L13.1521 1.65687C12.8648 1.41704 12.4422 1.45824 12.2054 1.74918L10.8571 3.40543L15.2215 7.04787Z" fill="#0066CC"/>
                      </svg>
                    </button>
                    <button class="note-icon-btn" type="button" (click)="deleteNote(i)" [attr.title]="'NOTES.DELETE' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 16.5 20.5" fill="none">
                        <path d="M15.75 1.0001C16.1642 1.0001 16.5 1.33588 16.5 1.7501C16.5 2.16431 16.1642 2.5001 15.75 2.5001H0.75C0.335786 2.5001 0 2.16431 0 1.7501C0 1.33588 0.335786 1.0001 0.75 1.0001H15.75Z" fill="#0066CC"/>
                        <path d="M14.75 3.5C14.9573 3.5 15.1551 3.58608 15.2969 3.7373C15.4385 3.88843 15.5113 4.09113 15.498 4.29785L14.498 19.7979C14.4726 20.1925 14.1455 20.5 13.75 20.5H2.74998C2.35452 20.5 2.0274 20.1925 2.00194 19.7979L1.00194 4.29785C0.988714 4.09113 1.06143 3.88843 1.20311 3.7373C1.34489 3.58608 1.54269 3.5 1.74998 3.5H14.75ZM3.45311 19H13.0469L13.9502 5H2.54979L3.45311 19Z" fill="#0066CC"/>
                        <path d="M10.7501 0C10.949 0 11.1397 0.0790743 11.2803 0.219727L12.2803 1.21973C12.4948 1.43421 12.5595 1.75687 12.4434 2.03711C12.3273 2.31737 12.0534 2.5 11.7501 2.5H4.75005C4.44671 2.5 4.17278 2.31737 4.05669 2.03711C3.94065 1.75687 4.0053 1.43421 4.21978 1.21973L5.21978 0.219727L5.33404 0.125977C5.45634 0.0444464 5.6009 0 5.75005 0H10.7501Z" fill="#0066CC"/>
                      </svg>
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      @if (notesExpanded) {
        <button class="btn-add-note" type="button" (click)="addNote()">
          {{ 'NOTES.ADD_NOTE' | translate }}
        </button>
      }
    </div>
  }
}
